document.addEventListener("DOMContentLoaded", () => {
  const INSURANCE_VARIANT_IDS = {
    500: "51300940677301",
    1000: "51300940710069",
    1500: "51300940742837",
    2000: "51300940775605",
    2500: "51300940808373",
    3000: "51300940841141",
    3500: "51300940873909",
    4000: "51300940906677",
    4500: "51300940939445",
    5000: "51300940972213",
    5500: "51300941004981",
    6000: "51300941037749",
    6500: "51300941070517",
    7000: "51300941103285",
    7500: "51300941136053",
    8000: "51300941168821",
    8500: "51300941201589",
    9000: "51300941234357",
    9500: "51300941267125",
    10000: "51300941299893",
    11000: "51300941299893",
    12000: "51300941299893",
    13000: "51300941299893",
    14000: "51300941299893",
    15000: "51300941299893",
    16000: "51300941299893",
    17000: "51300941299893",
    18000: "51300941299893",
    19000: "51300941299893",
    20000: "51300941299893",
  };

  const ALL_INSURANCE_VARIANTS = Object.values(INSURANCE_VARIANT_IDS);
  const currencyCode = window.Shopify?.currency?.active || 'USD';
  const currencyRate = window.Shopify?.currency?.rate || 1;

  // 1. 获取购物车，带上时间戳绕过浏览器缓存，确保数据是最新的
  const getCart = () => fetch(`/cart.js?v=${new Date().getTime()}`).then((res) => res.json());

  // 2. 计算真实总价（剔除已经存在于购物车里的保险费用，防止阶梯套娃跳跃）
  const getTrueCartSubtotal = (cart) => {
    const insuranceTotal = cart.items
      .filter((item) => ALL_INSURANCE_VARIANTS.includes(item.variant_id.toString()))
      .reduce((sum, item) => sum + item.final_line_price, 0);
    return cart.total_price - insuranceTotal;
  };

  const determineVariantId = (true_total_price) => {
    const priceInUsd = true_total_price / 100 / currencyRate; // 转为 USD 基准
    const tiers = Object.keys(INSURANCE_VARIANT_IDS).map(Number).sort((a, b) => a - b);
    
    for (let i = 0; i < tiers.length; i++) {
      if (priceInUsd <= tiers[i]) return INSURANCE_VARIANT_IDS[tiers[i]];
    }
    return INSURANCE_VARIANT_IDS[tiers[tiers.length - 1]]; // 超过上限的兜底方案
  };

  // 3. 使用 /cart/update.js 批量移除所有旧档位保险，减少网络请求
  const removeAllInsuranceVariants = async (cart) => {
    const updates = {};
    cart.items.forEach((item) => {
      if (ALL_INSURANCE_VARIANTS.includes(item.variant_id.toString())) {
        updates[item.key] = 0; // 按 item.key 设置数量为 0 来移除
      }
    });

    if (Object.keys(updates).length > 0) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });
    }
  };

  const updateInsuranceLabel = (truePriceCents) => {
    const labelEl = document.querySelector('label[for="add-insurance-checkbox"] strong');
    if (labelEl) {
      const estimatedFee = (truePriceCents / 100) * 0.02; // 2% 费用
      const formatted = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
      }).format(estimatedFee);

      labelEl.textContent = `Add Shipping Insurance (2%) ≈ ${formatted}`;
    }
  };

  let isProcessing = false;

  // 4. UI 状态同步函数（带防抖和延迟，专门解决 AJAX 购物车重绘导致的 Checkbox 取消选中问题）
  const syncUIAfterCartUpdate = () => {
    // 延迟 150ms 执行，等待 Shopify 主题的 DOM 重绘（Overwrite）完成
    setTimeout(async () => {
      const checkbox = document.getElementById("add-insurance-checkbox");
      if (!checkbox) return;

      try {
        const cart = await getCart();
        const trueSubtotal = getTrueCartSubtotal(cart);
        
        // 检查最新的购物车数据里是否真的包含保险变体
        const hasInsuranceInCart = cart.items.some((item) => 
          ALL_INSURANCE_VARIANTS.includes(item.variant_id.toString())
        );

        // 同步 UI
        checkbox.checked = hasInsuranceInCart;
        updateInsuranceLabel(trueSubtotal);
        
      } catch (err) {
        console.error("Failed to sync insurance UI:", err);
      }
    }, 150); 
  };

  // 5. 使用事件代理监听 Checkbox 交互，不再担心 DOM 刷新丢失事件
  document.addEventListener("change", async (e) => {
    if (e.target.id !== "add-insurance-checkbox" || isProcessing) return;

    const checkbox = e.target;
    isProcessing = true;
    checkbox.disabled = true; // 防连点

    try {
      const cart = await getCart();
      const trueSubtotal = getTrueCartSubtotal(cart);
      const newVariantId = determineVariantId(trueSubtotal);

      // 无论如何，先清空旧的保险项
      await removeAllInsuranceVariants(cart);

      // 如果当前是勾选状态，添加新档位的保险
      if (checkbox.checked && newVariantId) {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: newVariantId, quantity: 1 }),
        });
        if (!res.ok) throw new Error("Add insurance failed");
      }

      // 触发主题原生的购物车刷新事件
      document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
      
    } catch (err) {
      console.error("Insurance update error:", err);
      // 失败时回滚勾选状态
      checkbox.checked = !checkbox.checked; 
    } finally {
      checkbox.disabled = false;
      isProcessing = false;
      // 成功后，强制再同步一次 UI，确保万无一失
      syncUIAfterCartUpdate();
    }
  });

  // 监听主题全局购物车更新事件
  document.addEventListener("cart:updated", syncUIAfterCartUpdate);
  document.addEventListener("cart:refresh", syncUIAfterCartUpdate);

  // 6. 局部、轻量级的 DOM 监听（针对有些主题在点击加购后动态生成 DOM 的情况）
  const observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) {
        const checkbox = document.getElementById("add-insurance-checkbox");
        // 发现新渲染的 checkbox，且还没有同步过，立即同步
        if (checkbox && !checkbox.dataset.synced) {
          checkbox.dataset.synced = "true"; 
          syncUIAfterCartUpdate();
        }
      }
    }
  });
  
  // 只在必要时观察子节点的添加
  observer.observe(document.body, { childList: true, subtree: true });

  // 页面加载完成后的首次初始化
  syncUIAfterCartUpdate();
});